import React from 'react';
import { Button as AntButton, ButtonProps } from 'antd';
import './button.scss';

const Index: React.FC<ButtonProps> = ({ children, ...rest }) => (
    <AntButton {...rest}>{children}</AntButton>
);

export default Index;
